import React, { useState, useEffect } from 'react';
import axios from '../../axiosConfig';
import { Form, Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { useLoading } from '../../components/LoadingContext';
import { ToastContainer,toast } from 'react-toastify';
import { Card, Row, Col } from 'react-bootstrap'; 
import SelectComponent from '../../components/SelectComponent';



const userId = parseInt(localStorage.getItem('user'));  // ID del usuario logueado



const EditCohorte = () => {
  const [formData, setFormData] = useState({
    descripcion:'',
    // Indica si la cohorte sigue ABIERTA para inscribir. Sustituye al filtro por
    // año que hacía el frontend sobre el nombre de la cohorte.
    activo: true,

  });

  const { id } = useParams(); // Obtener el id del curso de la URL
  const { setLoading } = useLoading();
  const navigate = useNavigate();
  const [Cohorte,setCohorte]=useState('');
  const [codError, setCodError] = useState('');  // Estado para mensajes de error del cod
  const [isCodValid, setIsCodValid] = useState(true);  // Estado para indicar si el cod es válido
  const [originalCod, setOriginalCod] = useState('');  // Almacena el valor original del cod
  

  useEffect(() => {
    setLoading(true);
    Promise.all([getCohorte()]).finally(() => {
        setLoading(false);
    });
}, []);



  const getCohorte = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`/cohorte/${id}`,{headers: {
        Authorization: `Bearer ${token}`,
    }});
          
      const Cohorte = response.data;
      setCohorte(Cohorte);
      setFormData({
        descripcion: Cohorte.descripcion || '',
        // `!== false` y no `=== true`: si el backend todavía no envía el campo
        // (despliegue parcial) la cohorte se considera abierta.
        activo: Cohorte.activo !== false,

      });
      setOriginalCod(Cohorte.cod); // Guarda el valor original de cod

    } catch (error) {
      setError('Error fetching Cohorte');
      console.error('Error fetching Cohorte:', error);
    }
  };

  const [error, setError] = useState(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const emptyFields = Object.keys(formData).filter(key => {
      return !formData[key];  // Considerar vacíos los campos que no tienen valor
    });
  
    const hasEmptyFields = emptyFields.length > 0;
  
    try {
      const token = localStorage.getItem('token');
  
      if (!token) {
        toast.error('Error: Token no encontrado');
        return;
      }
  
      // 1. Actualizar los datos del curso
      const formDataWithStatus = {
        ...formData,
        status: !hasEmptyFields  // Si no hay campos vacíos, el status será true, de lo contrario, false
      };
  
      const procResponse = await axios.put(`/cohorte/${id}`, formDataWithStatus, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
     
            // Si hay campos vacíos, solo actualizamos los datos del participante
            toast.success('Formulario actualizado con éxito.');
        
  
      // Redirigir después de la actualización
      navigate('/cohorte');
  
    } catch (error) {
      // Captura cualquier error que ocurra en la solicitud
      toast.error('Error al actualizar curso o petición');
      console.error('Error actualizando:', error);
    }
  };
  

  return (
    <div className="row" style={{ marginTop: '50px' }}>
    <div className="col-lg-6 mx-auto"> {/* Centrado del contenido */}
      <div className="card-box" style={{ padding: '20px', width: '100%', margin: '0 auto' }}>
        <h2 className="mb-2">Actualizar Cohorte</h2>
        <Form onSubmit={handleSubmit} className="custom-gutter">
           
                                <Form.Group controlId="descripcion">
                                  <Form.Label>Nombre de Cohorte</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="descripcion"
                                    value={formData.descripcion}
                                    onChange={handleChange}
                                    maxLength={255}
                                    required
                                  />
                                </Form.Group>

                                <Form.Group controlId="activo" className="mt-3">
                                  <Form.Check
                                    type="switch"
                                    name="activo"
                                    label="Abierta para inscripción"
                                    checked={formData.activo}
                                    onChange={(e) =>
                                      setFormData((prev) => ({ ...prev, activo: e.target.checked }))
                                    }
                                  />
                                  <Form.Text className="text-muted">
                                    Al cerrarla deja de aparecer en los formularios de inscripción,
                                    pero se sigue viendo en los filtros y en las inscripciones que
                                    ya la tienen guardada.
                                  </Form.Text>
                                </Form.Group>
                         
        <div className="d-flex justify-content-end mt-3">
            <Button variant="secondary" onClick={() => navigate(-1)} className="me-2">
                Volver
            </Button>
            <Button variant="success" type="submit">
                Guardar
            </Button>
        </div>
      </Form>
    </div>
    </div>
    </div>
  );
};

export default EditCohorte;
